import React, { useEffect, useState } from "react";
import './CalendarCard.css';
import './Table.css';
import './Text.css';
import moment from 'moment-timezone';
import { nokkuNaal } from "../utils/nokkuNaal";
import { pirai } from "../utils/pirai";

console.log("process.env.SERVERURL", process.env.REACT_APP_SERVERURL);

const DayView = () => {
    // SSR Data Initialization
    const ssrData = (typeof window !== "undefined" && window.__INITIAL_DATA__) ? window.__INITIAL_DATA__ : null;
    const ssrDate = (typeof window !== "undefined" && window.__INITIAL_DATE__) ? window.__INITIAL_DATE__ : null;
    const d = (ssrData && ssrData.status === "success" && ssrData.data && ssrData.data[0]) ? ssrData.data[0] : null;

    const [getTotalRow, setTotalRow] = useState(ssrData ? ssrData.total_rows : 0);
    const [getMainTable, setMainTable] = useState(d ? d.main_table[0] : null);
    const [getStar, setStar] = useState(d ? d.star[0] : null);
    const [getKocharamTable, setKocharamTable] = useState(d ? d.kocharam[0] : null);
    const [getVirathamDays, setVirathamDays] = useState(d ? d.viratham : null);
    const [getImportantDays, setImportantDays] = useState(d ? d.important_day[0] : null);
    const [timeDetails, setTimeDetails] = useState(null);
    const [virathaDetails, setVirathaDetails] = useState([]);
    const [rasiDetails, setRasiDetails] = useState(d ? d.rasi : null);
    const [raguKuligaiEmakandam, setRaguKuligaiEmakandam] = useState(null);
    const [raguKuligaiEmakandamAdditional, setRaguKuligaiEmakandamAdditional] = useState(null);
    const [starDetails, setStarDetails] = useState(null);
    const [rasiBoxDetails, setRasiBoxDetails] = useState(null);
    const [minDate, setMinDate] = useState(d ? '2026-01-01' : null);
    const [maxDate, setMaxDate] = useState(d ? '2026-12-31' : null);
    const [loading, setLoading] = useState(!d);
    const [selectedText, setSelectedText] = useState(null);
    const [selectedPirai, setSelectedPirai] = useState(null)
    const [dayDetails, setDayDetails] = useState(null);


    //piraiType
    const [getPirai, setPirai] = useState(null)

    //nokkunaalType
    const [getNokkuNaal, setNokkuNaal] = useState(null)

    const [selectedNewDate, setSelectedNewDate] = useState(() => {
        if (ssrDate) return moment(ssrDate, "DD-MM-YYYY").tz("Asia/Kolkata");
        return moment().tz("Asia/Kolkata");
    });

    const [getDate, setDate] = useState(ssrDate || "01-01-2026");
    const [getMonth, setMonth] = useState(null);
    const [getWeekName, setWeekName] = useState(null);
    const [getMonthName, setMonthName] = useState(null);
    const [getTamilMonthName, setTamilMonthName] = useState(null);


    const [getHinduFes, setHinduFes] = useState(d ? d.main_table[0].hindu_fes : "-");
    const [getMuslimFes, setMuslimFes] = useState(d ? d.main_table[0].muslim_fes : "-");
    const [getChristFes, setChristFes] = useState(d ? d.main_table[0].chirs_fes : "-");
    const [getGov_holiday, setGov_holiday] = useState(d ? d.main_table[0].gov_holiday : "-");
    const [getImpDays, setImpDays] = useState(d ? d.main_table[0].important_days : "-");
    const [getImpDay, setImpDay] = useState(d ? d.important_day[0].imp_day : "-");


    const dateInputRef = React.useRef(null);

    // Your JSON data
    const timingsData = [
        {
            emakandam: "12.00 PM - 1.30 PM",
            kuligai: "3.00 PM - 4.30 PM",
            parikaram: 1,
            ragu: "4.30 PM - 6.00 PM",
            soolam: 2,
            weekday: 1,
        },
        {
            emakandam: "10.30 AM - 12.00 PM",
            kuligai: "1.30 PM - 3.00 PM",
            parikaram: 2,
            ragu: "7.30 AM - 9.00 AM",
            soolam: 1,
            weekday: 2,
        },
        {
            emakandam: "9.00 AM - 10.30 AM",
            kuligai: "12.00 PM - 1.30 PM",
            parikaram: 3,
            ragu: "3.00 PM - 4.30 PM",
            soolam: 4,
            weekday: 3,
        },
        {
            emakandam: "7.30 AM - 9.00 AM",
            kuligai: "10.30 AM - 12.00 PM",
            parikaram: 3,
            ragu: "12.00 PM - 1.30 PM",
            soolam: 4,
            weekday: 4,
        },
        {
            emakandam: "6.00 AM - 7.30 AM",
            kuligai: "9.00 AM - 10.30 AM",
            parikaram: 4,
            ragu: "1.30 PM - 3.00 PM",
            soolam: 3,
            weekday: 5,
        },
        {
            emakandam: "3.00 PM - 4.30 PM",
            kuligai: "7.30 AM - 9.00 AM",
            parikaram: 1,
            ragu: "10.30 AM - 12.00 PM",
            soolam: 2,
            weekday: 6,
        },
        {
            emakandam: "1.30 PM - 3.00 PM",
            kuligai: "6.00 AM - 7.30 AM",
            parikaram: 2,
            ragu: "9.00 AM - 10.30 AM",
            soolam: 1,
            weekday: 7,
        },
    ];

    const [popup, setPopup] = useState({ show: false, text: '', index: null });

    const showPopup = (text, index) => {
        setPopup({ show: true, text, index });

        // Hide after 1 second
        setTimeout(() => {
            setPopup({ show: false, text: '', index: null });
        }, 1000);
    };

    // Optional: Tamil weekday names
    const tamilWeekdays = [
        "ஞாயிறு", // 1
        "திங்கள்",
        "செவ்வாய்",
        "புதன்",
        "வியாழன்",
        "வெள்ளி",
        "சனி",
    ];

    useEffect(() => {
        if (getMainTable) {
            console.log("DayView: Already has data, skipping fetch");
            setLoading(false);
            return;
        }

        if (window.__INITIAL_DATA__) {
            console.log("DayView: Hydrating with SSR Data");
            const data = window.__INITIAL_DATA__;
            if (data.status === "success" && data.data.length > 0) {
                setTotalRow(data.total_rows);
                fetchPirai(data.data[0]);
                if (window.__INITIAL_DATE__) {
                    setDate(window.__INITIAL_DATE__);
                }
            }
            setLoading(false);
            return;
        }

        // Add mock data for development if backend is not available
        const isDevelopment = process.env.NODE_ENV === 'development';
        if (isDevelopment) {
            // Try to get real data first
            getDetails().catch(() => {
                // If backend fails, use mock data
                console.log('Backend not available, loading mock data...');
                loadMockData();
            });
        } else {
            // In Production, we strictly rely on SSR.
            console.log("Production mode: Relying on SSR data.");
        }
    }, []);

    const getNewDetails = async (inputDate) => {
        //clearAllDetails();
        const result = DateParserTamil({ inputDate: inputDate });
        fetchToday(result)
        setLoading(false);
    };

    const DateParserTamil = ({ inputDate }) => {
        // inputDate format: "dd-mm-yyyy"
        const [day, month, year] = inputDate.split("-").map(Number);

        const dateObj = new Date(year, month - 1, day);

        // Tamil Weekdays
        const tamilWeekdays = [
            "ஞாயிறு",   // Sunday
            "திங்கள்",  // Monday
            "செவ்வாய்", // Tuesday
            "புதன்",    // Wednesday
            "வியாழன்",  // Thursday
            "வெள்ளி",  // Friday
            "சனி"       // Saturday
        ];

        // Tamil Months (Gregorian in Tamil script)
        const tamilMonths = [
            "ஜனவரி", "பிப்ரவரி", "மார்ச்", "ஏப்ரல்", "மே", "ஜூன்",
            "ஜூலை", "ஆகஸ்ட்", "செப்டம்பர்", "அக்டோபர்", "நவம்பர்", "டிசம்பர்"
        ];

        // Tamil Calendar Months (சித்திரை - பங்குனி)
        const tamilCalMonths = [
            "சித்திரை",
            "வைகாசி",
            "ஆனி",
            "ஆடி",
            "ஆவணி",
            "புரட்டாசி",
            "ஐப்பசி",
            "கார்த்திகை",
            "மார்கழி",
            "தை",
            "மாசி",
            "பங்குனி"
        ];

        const tamilMonthName = tamilCalMonths[(month - 1) % 12];

        return {
            inputDate,
            day,
            month,
            year,
            week: dateObj.getDay(),
            weekName: tamilWeekdays[dateObj.getDay()],
            monthName: tamilMonths[dateObj.getMonth()],
            tamilMonthName: tamilMonthName
        };
    };

    const getDetails = async () => {
        try {

            const today = new Date();
            const day = String(today.getDate()).padStart(2, "0");     // 01–31
            const month = String(today.getMonth() + 1).padStart(2, "0"); // 01–12
            const year = today.getFullYear(); // e.g., 2026
            let formattedDate = `${day}-${month}-${year}`; // "01-01-2026"
            formattedDate = "01-01-2026"; // "01-01-2026"

            const result = DateParserTamil({ inputDate: formattedDate });

            const momentDate = moment(result.inputDate).tz("Asia/Kolkata");
            setSelectedNewDate(momentDate)

            setDate(result.inputDate);
            await Promise.all([
                fetchToday(result),
            ]);
        } catch (error) {
            console.error('Error fetching data from backend:', error);
            throw error; // Re-throw to trigger mock data loading
        }
    };

    function fetchPirai(data) {
        setMinDate('2026-01-01');
        setMaxDate('2026-12-31');
        setMainTable(data.main_table[0])
        setStar(data.star[0])
        setHinduFes(data.main_table[0].hindu_fes)
        setMuslimFes(data.main_table[0].muslim_fes)
        setChristFes(data.main_table[0].chirs_fes)
        setGov_holiday(data.main_table[0].gov_holiday)
        setImpDays(data.main_table[0].important_days)
        setImpDay(data.important_day[0].imp_day)
        setKocharamTable(data.kocharam[0])
        setVirathamDays(data.viratham)
        setImportantDays(data.important_day[0])
        setRasiDetails(data.rasi)
        /*if(data.main_table[0].pirai ){
            setPirai()
        } else if(data.main_table[0].pirai ){

        } else if(data.main_table[0].pirai ){

        }*/
    }

    const fetchToday = async (input) => {
        console.log("fetchToday", input.inputDate);

        /*const date = selectedNewDate.clone();
        setSelectedNewDate(date);*/

        setWeekName(input.weekName);
        setMonthName(input.monthName);
        setTamilMonthName(input.tamilMonthName);

        console.log("fetchToday week", input.week);
        console.log("fetchToday weekName", input.weekName);
        console.log("fetchToday monthName", input.monthName);
        console.log("fetchToday year", input.year);

        /*set weekday values*/
        const todayRaguKuligaiEmakandam = timingsData.find((item) => item.weekday === (input.week + 1));
        setRaguKuligaiEmakandam(todayRaguKuligaiEmakandam)

        //const url = `${process.env.REACT_APP_SERVERURL}/get_rasi_details?date=${todayDate}`;
        const url = `${process.env.REACT_APP_SERVERURL}/api/tamilcalendar/get_date?date=${input.inputDate}`;
        console.log("fetchToday", url);
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                console.log("data status", data.status);
                console.log("data total_rows", data.total_rows);
                console.log("Today Date data size", data.data.length);
                if (data.status === "success" && data.data.length > 0) {
                    setTotalRow(data.total_rows)
                    fetchPirai(data.data[0])
                } else {
                    setRasiDetails(null); // no record found
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setRasiDetails(null); // fallback in case of error
            });
    };

    const loadMockData = () => {
        const today = moment().tz('Asia/Kolkata');

        // Mock time details
        setTimeDetails({
            month: 'December',
            weekday: 'Wednesday',
            date: today.format('DD/MM/YYYY'),
            tam_year: 'விகாரி',
            tam_month: 'மார்கழி',
            tam_day: 'முன்றாம்',
            nallanerem_m: '6:30 - 8:45',
            nallanerem_e: '5:15 - 6:30',
            gowrineram_m: '7:30 - 9:00',
            gowrineram_e: '4:45 - 5:45',
            laknam: 5,
            laknam_time: '5:30 - 7:30',
            sooriya_r: '6:25',
            karanam: 'பத்ரை'
        });

        // Mock viratha details
        setVirathaDetails([
            { viratham: 'ஏகாதசி', time: '6:00' },
            { viratham: 'சுபமுகூர்த்தம்', time: '-' }
        ]);

        // Mock ragu kuligai emakandam
        setRaguKuligaiEmakandam({
            ragu: '12:30 - 2:00',
            kuligai: '3:00 - 4:30',
            emakandam: '10:30 - 12:00',
            soolam: 'கிழக்கு',
            parikaram: 'துலசி'
        });

        // Mock additional details
        setRaguKuligaiEmakandamAdditional({
            thiti: 'ஏகாதசி',
            nama_yogam: 'சுபயோகம்',
            karanam: 'பத்ரை',
            yokam: 'அமிர்த யோகம்',
            chanthran: 'மீனம்',
            nethiram: 'உத்திராடம்',
            jeevan: 'சுபம்',
            day_type: 'மேல் நோக்கு நாள்',
            pirai: '1',
            leave_flag: 0,
            importantday: 'திருவெம்பாவை துவக்கம்',
            hindu_fes: 'வைகுண்ட ஏகாதசி',
            muslim_fes: '-',
            chirs_fes: 'sfsgdsgdsg',
            gov_holiday: 'sggasg'
        });

        // Mock star details
        setStarDetails({
            Time1: '6:30 AM',
            Time2: '2:30 PM',
            Nat1: 'உத்திராடம்',
            Nat2: 'திருவோணம்',
            Nat3: 'அவிட்டம்',
            date: today.format('DD-MM-YYYY')
        });

        // Mock rasi box details
        setRasiBoxDetails({
            c1: 'சூ', c2: 'செ', c3: 'அ', c4: 'கு',
            c5: 'சு', c6: 'கே', c7: 'ரா', c8: 'ச',
            c9: 'கு', c10: 'சு', c11: 'பு', c12: 'ரா'
        });

        // Mock day details
        setDayDetails({
            imp_day: 'வைகுண்ட ஏகாதசி'
        });

        // Set date limits
        setMinDate('2026-01-01');
        setMaxDate('2026-12-31');

        // Set selected images
        setSelectedText('/melnokku.png');
        setSelectedPirai('/pirai2.png');

        setLoading(false);
        console.log('Mock data loaded successfully!');
    };

    const handlePrevious = () => {
        const [day, month, year] = getDate.split("-").map(Number);
        const newDate = new Date(year, month - 1, day - 1);
        const newDay = String(newDate.getDate()).padStart(2, "0");
        const newMonth = String(newDate.getMonth() + 1).padStart(2, "0");
        const newYear = newDate.getFullYear();
        let newDateFormatted = `${newDay}-${newMonth}-${newYear}`;
        window.location.assign(`/day?date=${newDateFormatted}`);
    };

    const handleNext = () => {
        const [day, month, year] = getDate.split("-").map(Number);
        const newDate = new Date(year, month - 1, day + 1);
        const newDay = String(newDate.getDate()).padStart(2, "0");
        const newMonth = String(newDate.getMonth() + 1).padStart(2, "0");
        const newYear = newDate.getFullYear();
        let newDateFormatted = `${newDay}-${newMonth}-${newYear}`;
        window.location.assign(`/day?date=${newDateFormatted}`);
    };

    const handleIconClick = () => {
        dateInputRef.current.showPicker?.();
        dateInputRef.current.click();
    };

    const handleDateChange = (e) => {
        const selectedDate = e.target.value;
        console.log("selectedDate 123", selectedDate);
        if (selectedDate) {
            const [year, month, day] = selectedDate.split("-").map(Number);
            const newDate = new Date(year, month - 1, day);
            const newDay = String(newDate.getDate()).padStart(2, "0");
            const newMonth = String(newDate.getMonth() + 1).padStart(2, "0");
            const newYear = newDate.getFullYear();
            let newDateFormatted = `${newDay}-${newMonth}-${newYear}`;
            window.location.assign(`/day?date=${newDateFormatted}`);
        }
    };
    const refreshDate = () => {
        window.location.assign('/day');
    }

    if (loading) {

    }

    const virathamName = [
        "அமாவாசை",
        "கிரிவலம்",
        "பௌர்ணமி",
        "கிருத்திகை",
        "தேய்பிறை சஷ்டி",
        "சஷ்டி",
        "சங்கடஹர சதுர்த்தி",
        "அஷ்டமி",
        "நவமி",
        "தசமி",
        "சிவராத்திரி",
        "சந்திர தரிசனம்",
        "ஏகாதசி",
        "பிரதோஷம்",
        "சதுர்த்தி",
        "திருவாதிரை",
        "திருவோணம்",
        "சனி மஹா பிரதோஷம்",
        "மஹா சிவராத்திரி",
        "ஆடி அமாவாசை",
        "சுபமுகூர்த்தம்",
        "கரிநாள்",
        "தேய்பிறை அஷ்டமி",
        "தை அமாவாசை",
        "மஹா சங்கடஹர சதுர்த்தி",
        "நாக சதுர்த்தி",
        "",
    ]

    const tamilCalMonths = [
        "சித்திரை",
        "வைகாசி",
        "ஆனி",
        "ஆடி",
        "ஆவணி",
        "புரட்டாசி",
        "ஐப்பசி",
        "கார்த்திகை",
        "மார்கழி",
        "தை",
        "மாசி",
        "பங்குனி"
    ];

    function getVirathamImage(str) {
        console.log("viratham day in adapter", str);
        if (str.includes("கிருத்திகை") || str.includes("கார்த்திகை")) {
            return "/karthigai.png";
        }
        if (str.includes("பௌர்ணமி")) {
            return "/fullmoon.png";
        }
        if (str.includes("அமாவாசை")) {
            return "/blackmoon.png";
        }
        if (str.includes("ஏகாதசி")) {
            return "/ekadasi.png";
        }

        if (str.includes("சஷ்டி")) {
            return "/shasti.png";
        }

        if (str.includes("சங்கடஹர சதுர்த்தி")) {
            return "/sankataharachaturti.png";
        }

        if (str.includes("சிவராத்திரி")) {
            return "/shivaratri.png";
        }

        if (str.includes("பிரதோஷம்")) {
            return "/pirathoosam.png";
        }

        if (str === "சதுர்த்தி") {
            return "/chaturthi.png";
        }

        if (str.includes("திருவோணம்")) {
            return "/thiruvona.png";
        }
        return "";
    }

    function getStarText() {
        if (!getStar) return ""; // No data

        const { t1, t2, s1, s2, s3, date } = getStar;

        // Ensure Time1 and Time2 are valid strings
        const time1Str = typeof t1 === "string" ? t1.replace(/:/g, ".") : "";
        const time2Str = typeof t2 === "string" ? t2.replace(/:/g, ".") : "";
        const str = date || ""; // Fallback if date is undefined

        console.log("time1Str:", t1);
        console.log("time2Str:", t2);
        console.log("str:", str);

        if (t1 === "-" || !t1) {
            return s1 === "-" || !s1 ? "-" : `இன்று முழுவதும் ${s1}`;
        } else {
            if (t2 && t2 !== "-") {
                return (
                    `இன்று ${getPoluthu(str, t1)} ${time1Str.replace(/ AM| PM/g, "")} வரை ${s1}` +
                    ` பின்பு ${getPoluthu(str, t2)} ${time2Str.replace(/ AM| PM/g, "")} வரை ${s2} பின்பு ${s3}`
                );
            } else {
                return (
                    `இன்று ${getPoluthu(str, t1)} ${time1Str.replace(/ AM| PM/g, "")} வரை ${s1}` +
                    ` பின்பு ${s2}`
                );
            }
        }
    }

    function getPoluthu(strDate, strr1) {
        // Remove AM/PM and split time
        const strr = strr1.replace(/:/g, ".");
        const timee = strr.replace(/\s?(AM|PM)/g, "");
        const output = timee.split(".");

        let hourOfDay;
        if (strr1.includes("PM")) {
            hourOfDay = parseInt(output[0]) !== 12 ? parseInt(output[0]) + 12 : 12;
        } else {
            hourOfDay = parseInt(output[0]) === 12 ? 0 : parseInt(output[0]);
        }

        // Log for debugging
        console.log(`hourOfDay == : ${hourOfDay} - ${strDate}`);

        if (hourOfDay >= 0 && hourOfDay <= 5) {
            return "அதிகாலை";
        } else if (hourOfDay >= 6 && hourOfDay <= 11) {
            return "காலை";
        } else if (hourOfDay >= 12 && hourOfDay <= 14) {
            return "பிற்பகல்";
        } else if (hourOfDay >= 15 && hourOfDay <= 18) {
            return "மாலை";
        } else if (hourOfDay >= 19 && hourOfDay <= 24) {
            return "இரவு";
        } else {
            return ""; // Fallback case
        }
    }

    function getAyanam(input) {
        let output = "";
        if (input === "1") {
            output = "உத்தராயணம்";
        } else if (input === "2") {
            output = "தட்சிணாயணம்";
        }
        return output
    }

    function getRuthu(input) {
        let output = "";
        if (input === "சித்திரை") {
            output = "மேஷம் மாதம் - வசந்த ருது";
        } else if (input === "வைகாசி") {
            output = "ரிஷபம் மாதம் - வசந்த ருது";
        } else if (input === "ஆனி") {
            output = "மிதுனம் மாதம் - கிரீஷ்ம ருது";
        } else if (input === "ஆடி") {
            output = "கடகம் மாதம் - கிரீஷ்ம ருது";
        } else if (input === "ஆவணி") {
            output = "சிம்மம் மாதம் - வருஷ ருது";
        } else if (input === "புரட்டாசி") {
            output = "கன்னி மாதம் - வருஷ ருது";
        } else if (input === "ஐப்பசி") {
            output = "துலாம் மாதம் - சரத் ருது";
        } else if (input === "கார்த்திகை") {
            output = "விருச்சிகம் மாதம் - சரத் ருது";
        } else if (input === "மார்கழி") {
            output = "தனுசு மாதம் - ஹேமந்த ருது";
        } else if (input === "தை") {
            output = "மகரம் மாதம் - ஹேமந்த ருது";
        } else if (input === "மாசி") {
            output = "கும்பம் மாதம் - வசந்த ருது";
        } else if (input === "பங்குனி") {
            output = "மீனம் மாதம் - சிசிர ருது";
        }
        return output
    }


    const specialValues = [
        getHinduFes,
        getChristFes,
        getMuslimFes,
        getGov_holiday,
        getImpDays,
        getImpDay
    ].filter(value => value && value.trim() !== '-')
        .filter((v, i, a) => a.indexOf(v) === i);

    return (
        <div className="container my-3 mx-0">
            <div className="d-flex justify-content-between align-items-center header-bar"
                style={{ padding: '10px 10px' }}>
                <div className="header-title" style={{ color: "#e53935" }}>தினசரி காலண்டர்</div>
                <div className="d-flex gap-2 header-icons">
                    <i
                        className="bi bi-arrow-clockwise"
                        style={{ cursor: "pointer" }}
                        onClick={refreshDate}
                    />
                    <div>

                    </div>
                    <i
                        className="bi bi-calendar"
                        style={{ cursor: "pointer" }}
                        onClick={handleIconClick}
                    />
                    <input
                        ref={dateInputRef}
                        type="date"
                        min={minDate}
                        max={maxDate}
                        value={selectedNewDate.format("YYYY-MM-DD")}
                        style={{ display: "none" }}
                        onChange={handleDateChange}
                    />
                </div>
            </div>
            <div
                className="date-card my-2 mx-0 shadow-none px-0 py-2 d-flex justify-content-between align-items-center">
                {getDate !== minDate ?
                    <i
                        className="bi bi-chevron-left fs-2 my-4 mx-2 text-white"
                        style={{ cursor: "pointer" }}
                        onClick={handlePrevious}
                    />
                    : <i className="bi bi-chevron-left fs-2" style={{ cursor: "not-allowed", color: "#000000" }} />
                }
                {getDate && (
                    <div className="text-center">
                        <div className="text-size-14">{getMonthName} - {getWeekName}</div>
                        <div className="text-size-28 text-bold">{getDate}</div>
                        {getTotalRow !== 0 ? (
                            <div className="text-size-14">
                                <div className="text-size-14">{getMainTable.tam_year} - {tamilCalMonths[getMainTable.tam_month - 1]} - {getMainTable.tam_day}</div>
                                <div className="text-size-12">{getRuthu(tamilCalMonths[getMainTable.tam_month - 1])} - {getAyanam(getMainTable.ayanam)}</div>
                            </div>
                        ) : <div className="text-size-14"></div>
                        }
                    </div>
                )}
                {selectedNewDate.format("YYYY-MM-DD") !== maxDate ?
                    <i
                        className="bi bi-chevron-right fs-2 my-4 mx-2 text-white"
                        style={{ cursor: "pointer" }}
                        onClick={handleNext}
                    />
                    : <i className="bi bi-chevron-right fs-2" style={{ cursor: "not-allowed", color: "#e53935" }} />
                }
            </div>
            {getTotalRow === 0
                ?
                (<div>
                    {raguKuligaiEmakandam && (
                        <div className="table-container">
                            <table className="responsive-table">
                                <thead>
                                    <tr>
                                        <th className="table-header">இராகு, குளிகை, எமகண்டம்</th>
                                    </tr>
                                </thead>
                            </table>
                            <table className="responsive-table">
                                <tbody>
                                    <tr>
                                        <th className="table-header2">இராகு</th>
                                        <td className="table-cell">{raguKuligaiEmakandam?.ragu && raguKuligaiEmakandam.ragu.trim() !== ''
                                            ? raguKuligaiEmakandam.ragu
                                            : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th className="table-header2">குளிகை</th>
                                        <td className="table-cell">{raguKuligaiEmakandam?.kuligai && raguKuligaiEmakandam.kuligai.trim() !== ''
                                            ? raguKuligaiEmakandam.kuligai
                                            : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th className="table-header2">எமகண்டம்</th>
                                        <td className="table-cell">{raguKuligaiEmakandam?.emakandam && raguKuligaiEmakandam.emakandam.trim() !== ''
                                            ? raguKuligaiEmakandam.emakandam
                                            : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th className="table-header2">கரணன்</th>
                                        <td className="table-cell">1.30 PM - 3.00 PM</td>
                                    </tr>
                                    <tr>
                                        <th className="table-header2">சூலம்</th>
                                        <td className="table-cell">கிழக்கு</td>
                                    </tr>
                                    <tr>
                                        <th className="table-header2">பரிகாரம்</th>
                                        <td className="table-cell">தயிர்</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                    <div style={{ height: "10px", width: "100%" }}></div>
                    <div className="text-center table-cell text-bold">மற்ற தகவல்கள் இல்லை...</div>
                </div>)
                :
                (<div>
                    {getMainTable.is_leave === "1" && (
                        <div>
                            <div className="text-bold text-center"
                                style={{ color: 'red', fontSize: '14px', padding: '10px' }}>
                                அரசு விடுமுறை
                            </div>
                        </div>
                    )}
                    <div className="moon-icon text-center">
                        {getVirathamDays && getVirathamDays.length > 0 && (
                            getVirathamDays
                                .map((item, index) =>
                                    `${virathamName[item.viratham - 1]}` !== 'சுபமுகூர்த்தம்' &&
                                    getVirathamImage(`${virathamName[item.viratham - 1]}`) !== '' && (
                                        <div key={item.viratham + index}
                                            style={{ position: 'relative', display: 'inline-block' }}>
                                            {popup.show && popup.index === index && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '-80%',
                                                    transform: 'translateY(-50%)',
                                                    backgroundColor: '#333',
                                                    color: '#fff',
                                                    padding: '5px 10px',
                                                    borderRadius: '4px',
                                                    fontSize: '12px',
                                                    whiteSpace: 'nowrap',
                                                    zIndex: 1000,
                                                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
                                                }}>
                                                    {popup.text}
                                                </div>
                                            )}
                                            <img src={getVirathamImage(`${virathamName[item.viratham - 1]}`)} alt={index}
                                                height={40} width={40} key={index}
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => showPopup(`${virathamName[item.viratham - 1]}`, index)}
                                                onMouseOver={() => showPopup(`${virathamName[item.viratham - 1]}`, index)}></img>
                                        </div>

                                    )
                                )
                        )}

                        {getVirathamDays && getVirathamDays.length > 0 && (
                            getVirathamDays
                                .map((item, index) =>
                                    `${virathamName[item.viratham - 1]}` === 'சுபமுகூர்த்தம்' && (
                                        <div key={item.viratham + index}
                                            style={{ position: 'relative', display: 'inline-block' }}>
                                            {popup.show && popup.index === index && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '-80%',
                                                    transform: 'translateY(-50%)',
                                                    backgroundColor: '#333',
                                                    color: '#fff',
                                                    padding: '5px 10px',
                                                    borderRadius: '4px',
                                                    fontSize: '12px',
                                                    whiteSpace: 'nowrap',
                                                    zIndex: 1000,
                                                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
                                                }}>
                                                    {popup.text}
                                                </div>
                                            )}
                                            <img src={"/subamuhurtham.png"} alt={index} height={40} width={40} key={index}
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => showPopup(`${virathamName[item.viratham - 1]}`, index)}
                                                onMouseOver={() => showPopup(`${virathamName[item.viratham - 1]}`, index)}></img>
                                        </div>

                                    )
                                )
                        )}
                    </div>

                    {specialValues.length > 0 && (
                        <div className="table-container">
                            {getVirathamDays && getVirathamDays.length > 0 && (
                                <table className="responsive-table">
                                    <thead>
                                        <th className="table-header">
                                            {getVirathamDays && getVirathamDays.length > 0 && (
                                                <div>
                                                    <div
                                                        className="card-header"
                                                        style={{
                                                            paddingLeft: '1rem',
                                                            paddingRight: '1rem',
                                                            fontSize: '12px',
                                                        }}
                                                    >
                                                        {getVirathamDays
                                                            .map(item =>
                                                                item.time && item.time.trim() !== '-'
                                                                    ? `${virathamName[item.viratham - 1]} (${item.time})`
                                                                    : `${virathamName[item.viratham - 1]}`
                                                            )
                                                            .join(', ')
                                                        }
                                                    </div>
                                                </div>
                                            )}
                                        </th>
                                    </thead>
                                </table>
                            )}
                            <table className="responsive-table">
                                <tbody>
                                    <tr>
                                        <td className="table-cell">
                                            {specialValues.length > 0 && (
                                                <div>
                                                    <div className="special-text text-center text-bold py-0" style={{
                                                        color: 'green', paddingLeft: '1rem',
                                                        paddingRight: '1rem',
                                                        fontSize: '12px',
                                                    }}>
                                                        {specialValues.join(', ')}
                                                    </div>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}


                    <div style={{ height: "10px", width: "100%" }}></div>
                    {getMainTable && (
                        <div className="table-container">
                            <table className="responsive-table">
                                <thead>
                                    <th className="table-header2">
                                        {pirai(getMainTable.pirai)}
                                    </th>
                                    <th className="table-header2">
                                        {nokkuNaal(`${getMainTable.day_type}`)}
                                    </th>
                                </thead>
                            </table>
                        </div>
                    )}
                    <div style={{ height: "10px", width: "100%" }}></div>
                    {getMainTable && (
                        <div className="table-container">
                            <table className="responsive-table">
                                <thead>
                                    <th className="table-header">நல்ல நேரம்</th>
                                </thead>
                            </table>
                            <table className="responsive-table">
                                <tbody>
                                    <tr>
                                        <td className="table-cell table-text">காலை</td>
                                        <td className="table-cell">{getMainTable.nallaneram_m}</td>
                                    </tr>
                                    <tr>
                                        <td className="table-cell table-text">மாலை</td>
                                        <td className="table-cell">{getMainTable.nallaneram_e}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ height: "10px", width: "100%" }}></div>
                            <table className="responsive-table">
                                <thead>
                                    <th className="table-header">கெளரி நல்ல நேரம்</th>
                                </thead>
                            </table>
                            <table className="responsive-table">
                                <tbody>
                                    <tr>
                                        <td className="table-cell table-text">காலை</td>
                                        <td className="table-cell">{getMainTable.gowri_neram_m}</td>
                                    </tr>
                                    <tr>
                                        <td className="table-cell table-text">மாலை</td>
                                        <td className="table-cell">{getMainTable.gowri_neram_e}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                    <div style={{ height: "10px", width: "100%" }}></div>

                    {raguKuligaiEmakandam && (
                        <div className="table-container">
                            <table className="responsive-table">
                                <tr>
                                    {/*<th className="table-header">நால்வர் காலங்கள்</th>*/}
                                    <th className="table-header">இராகு, குளிகை, எமகண்டம்</th>
                                </tr>
                            </table>
                            <table className="responsive-table">
                                <thead>
                                    <tr>
                                        <th className="table-header2">இராகு</th>
                                        <td className="table-cell">{raguKuligaiEmakandam?.ragu && raguKuligaiEmakandam.ragu.trim() !== ''
                                            ? raguKuligaiEmakandam.ragu
                                            : '-'}</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th className="table-header2">குளிகை</th>
                                        <td className="table-cell">{raguKuligaiEmakandam?.kuligai && raguKuligaiEmakandam.kuligai.trim() !== ''
                                            ? raguKuligaiEmakandam.kuligai
                                            : '-'}</td>
                                    </tr>
                                </tbody>
                                <tr>
                                    <th className="table-header2">எமகண்டம்</th>
                                    <td className="table-cell">{raguKuligaiEmakandam?.emakandam && raguKuligaiEmakandam.emakandam.trim() !== ''
                                        ? raguKuligaiEmakandam.emakandam
                                        : '-'}</td>
                                </tr>
                                <tr>
                                    <th className="table-header2">கரணன்</th>
                                    <td className="table-cell">1.30 PM - 3.00 PM</td>
                                </tr>
                                <tr>
                                    <th className="table-header2">சூலம்</th>
                                    <td className="table-cell">கிழக்கு</td>
                                </tr>
                                <tr>
                                    <th className="table-header2">பரிகாரம்</th>
                                    <td className="table-cell">தயிர்</td>
                                </tr>
                            </table>
                        </div>
                    )}

                    <div style={{ height: "10px", width: "100%" }}></div>

                    {getMainTable && (
                        <div className="table-container">
                            <table className="responsive-table">
                                <tr>
                                    <th className="table-header">இன்றைய பஞ்சாங்க குறிப்புகள்</th>
                                </tr>
                            </table>
                            <table className="responsive-table">
                                <thead>
                                    <tr>
                                        <th className="table-header2">திதி</th>
                                        <th className="table-header2">நட்சத்திரம்</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="table-cell">{getMainTable.thithi}</td>
                                        <td className="table-cell">{getStarText()}</td>
                                    </tr>
                                </tbody>
                                <tr>
                                    <th className="table-header2">நாமயோகம்</th>
                                    <th className="table-header2">அமிர்தாதி யோகம்</th>
                                </tr>
                                <tr>
                                    <td className="table-cell">{getMainTable.nama_yogam}
                                    </td>
                                    <td className="table-cell">{getMainTable.am}
                                    </td>
                                </tr>
                                <tr>
                                    <th className="table-header2">கரணம்</th>
                                    <th className="table-header2">சந்திராஷ்டமம்</th>
                                </tr>
                                <tr>
                                    <td className="table-cell">{getMainTable.karanam}</td>
                                    <td className="table-cell">{getMainTable.chanthran}</td>
                                </tr>
                                <tr>
                                    <th className="table-header2">நேத்திரம்</th>
                                    <th className="table-header2">ஜீவன்</th>
                                </tr>
                                <tr>
                                    <td className="table-cell">{getMainTable.nethiram}</td>
                                    <td className="table-cell">{getMainTable.jeevan}</td>
                                </tr>
                            </table>
                        </div>
                    )}

                    <div style={{ height: "10px", width: "100%" }}></div>

                    {getKocharamTable && (
                        <div className="table-container">
                            <table className="responsive-table">
                                <th className="table-header">கோச்சார கட்டம்</th>
                            </table>
                            <div className="horoscope-grid mx-auto">
                                <div className="cell text-center">{getKocharamTable.c1}</div>
                                <div className="cell text-center">{getKocharamTable.c2}</div>
                                <div className="cell text-center">{getKocharamTable.c3}</div>
                                <div className="cell text-center">{getKocharamTable.c4}</div>

                                <div className="cell text-center">{getKocharamTable.c12}</div>
                                <div className="cell span-row-2 span-col-2">
                                    <div>
                                        {Array.from({ length: 7 })
                                            .map((_, i) => getKocharamTable[`m${i + 1}`])
                                            .filter((val) => val && val.trim() !== "-")
                                            .map((val, idx, arr) => (
                                                <span key={idx}>{val}{idx < arr.length - 1 && ","}<br /></span>
                                            ))}
                                    </div>
                                </div>
                                <div className="cell text-center">{getKocharamTable.c5}</div>

                                <div className="cell text-center">{getKocharamTable.c11}</div>
                                <div className="cell text-center">{getKocharamTable.c6}</div>

                                <div className="cell text-center">{getKocharamTable.c10}</div>
                                <div className="cell text-center">{getKocharamTable.c9}</div>
                                <div className="cell text-center">{getKocharamTable.c8}</div>
                                <div className="cell text-center">{getKocharamTable.c7}</div>
                            </div>
                        </div>
                    )}

                    <div style={{ height: "10px", width: "100%" }}></div>

                    {rasiDetails && (
                        <div className="table-container">
                            <table className="responsive-table">
                                <th className="table-header">இன்றைய ராசிபலன்</th>
                            </table>
                            <table className="responsive-table">
                                <tr>
                                    <th className="table-header2">மேஷம்</th>
                                    <td className="table-header2">{rasiDetails[0].r1}</td>
                                </tr>

                                <tr>
                                    <th className="table-header2">ரிஷபம்</th>
                                    <td className="table-header2">{rasiDetails[0].r2}</td>
                                </tr>
                                <tr>
                                    <th className="table-header2">மிதுனம்</th>
                                    <td className="table-header2">{rasiDetails[0].r3}</td>
                                </tr>
                                <tr>
                                    <th className="table-header2">கடகம்</th>
                                    <td className="table-header2">{rasiDetails[0].r4}</td>
                                </tr>
                                <tr>
                                    <th className="table-header2">சிம்மம்</th>
                                    <td className="table-header2">{rasiDetails[0].r5}</td>
                                </tr>
                                <tr>
                                    <th className="table-header2">கன்னி</th>
                                    <td className="table-header2">{rasiDetails[0].r6}</td>
                                </tr>
                                <tr>
                                    <th className="table-header2">துலாம்</th>
                                    <td className="table-header2">{rasiDetails[0].r7}</td>
                                </tr>
                                <tr>
                                    <th className="table-header2">விருச்சிகம்</th>
                                    <td className="table-header2">{rasiDetails[0].r8}</td>
                                </tr>
                                <tr>
                                    <th className="table-header2">தனுசு</th>
                                    <td className="table-header2">{rasiDetails[0].r9}</td>
                                </tr>
                                <tr>
                                    <th className="table-header2">மகரம்</th>
                                    <td className="table-header2">{rasiDetails[0].r10}</td>
                                </tr>
                                <tr>
                                    <th className="table-header2">கும்பம்</th>
                                    <td className="table-header2">{rasiDetails[0].r11}</td>
                                </tr>
                                <tr>
                                    <th className="table-header2">மீனம்</th>
                                    <td className="table-header2">{rasiDetails[0].r12}</td>
                                </tr>
                            </table>
                        </div>
                    )
                    }

                    <div style={{ height: "10px", width: "100%" }}></div>

                    {getMainTable && (
                        <div className="table-container">
                            <table className="responsive-table">
                                <thead>
                                    <th className="table-header">இன்றைய பொன்மொழி</th>
                                </thead>
                                <tbody>
                                    <th className="table-header2">{getMainTable.quote}</th>
                                </tbody>
                            </table>
                        </div>
                    )}

                    <div style={{ height: "10px", width: "100%" }}></div>

                    {getImportantDays && (
                        <div className="table-container">
                            <table className="responsive-table">
                                <thead>
                                    <th className="table-header">இன்றைய பிறந்த நாள்</th>
                                </thead>
                                <tbody>
                                    <th className="table-header2">{getImportantDays.birth}</th>
                                </tbody>
                            </table>
                        </div>
                    )}

                    <div style={{ height: "10px", width: "100%" }}></div>

                    {getImportantDays && (
                        <div className="table-container">
                            <table className="responsive-table">
                                <thead>
                                    <th className="table-header">இன்றைய நினைவு நாள்</th>
                                </thead>
                                <tbody>
                                    <th className="table-header2">{getImportantDays.death}</th>
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>)
            }
        </div>

    );
}

export default DayView;
